import './OpRadio.scss'

import React from 'react'
import cx from 'bem-classnames'

const OpRadio = ({label, checked, disabled, onChange, labelClass, divClass}) => {
  const btnClasses = {
    name: 'OpRadio__button',
    modifiers: ['checked', 'disabled']
  }

  const labelClasses = {
    name: 'OpRadio__label',
    modifiers: ['disabled']
  }

  const divClasses = {
    name: "OpRadio",
    modifiers: ['disabled']
  }

  const btnClass = cx(btnClasses, {
    checked,
    disabled
  })

  let labelClazz = cx(labelClasses, {
    disabled
  })
  if (labelClass) {
    labelClazz += ` ${labelClass}`
  }

  let divClazz = cx(divClasses, { disabled })
  if (divClass) {
    divClazz += ` ${divClass}`
  }

    return (
      <div className={divClazz} onClick={() => !disabled && onChange()}>
        <div className={btnClass}/>
        <label className={labelClazz}>{label}</label>
      </div>
    )
}

export default OpRadio
